firebird.directive('waitingRoomMarquee', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'waiting-room-marquee.html'),
            link: function (scope, element) {}
        };
    }
]);
